import { render, staticRenderFns } from "./WorkRecordSub.vue?vue&type=template&id=3c78a357"
import script from "./WorkRecordSub.vue?vue&type=script&lang=js"
export * from "./WorkRecordSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports